import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

/** Sends one GA4 page_view per route change (including the initial load). */
const AnalyticsTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // page_path gets the pathname only; GA4 derives query strings from
    // page_location itself, so including `search` here doubled them in
    // landing-page reports (e.g. /?age=...?age=...).
    trackPageView(pathname);
  }, [pathname, search]);

  return null;
};

export default AnalyticsTracker;
